import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { AppContext } from '../../../context/app'
import {
  captureGAEvent,
  create_share_url,
  getAudioTrailerUrl,
  getImage,
  getReleaseDate,
  raiseToast,
  secondsToHms,
  redirectToAthletePage,
} from '../../../utils/helper'
import '../contentDetail.css'
import TrailerPlayer from '../../player/trailerPlayer'
import RedCircle from '../../../assets/red_circle.gif'
import GreyCircle from '../../../assets/greycircle.png'
import Player from '../../player/player'
import useAxios from 'axios-hooks'
import { SubscriptionContext } from '../../../context/subscription'
import { isEmpty } from 'lodash'
import { CONTENT_WATCH_URL, DETAIL_CONTENT } from '../../../utils/apiUrls'
import { useLocation, useSearchParams } from 'react-router-dom'
import LiveCounter from '../liveCounter'
import { useTranslation } from 'react-i18next'
import CustomImage from '../../../components/customImage/customImage'
import VideoPlaceholder from '../../../assets/video-content.png'
import ShowMoreText from 'react-show-more-text'
import { withTheme } from 'theming'
import ShareModal from '../../../components/shareModal/shareModal'
import ContentDetailBottom from '../contentDetailBottom'
import { ContentContext } from '../../../context/content'
import AudioTrailerPlayer from '../../../components/audioPlayer/audioTrailerPlayer'
import CustomMetadata from '../../../components/customMetadata/customMetadata'
import { useInterval } from '../../../hooks/useInterval'
import DefaultContentWrapper from './defaultContentWrapper'
import AggregateRatingReviewWidget from '../../../components/reviewRating/aggregateRatingReviewWidget'
import StreamingSoonIcon from '../../../assets/imgComponents/streamingSoonIcon'
import ListenIcon from '../../../assets/imgComponents/listenIcon'
import PlayIcon from '../../../assets/imgComponents/playIcon'
import ResumeWatchingIcon from '../../../assets/imgComponents/resumeWatchingIcon'
import PauseIcon from '../../../assets/imgComponents/pauseIcon'
import ShareIcon from '../../../assets/imgComponents/hoverableIcons/shareIcon'
import AddedToPlaylist from '../../../assets/imgComponents/hoverableIcons/addedToPlaylist'
import AddToPlaylist from '../../../assets/imgComponents/hoverableIcons/addToPlaylist'
import AddedToFav from '../../../assets/imgComponents/hoverableIcons/addedToFav'
import AddToFav from '../../../assets/imgComponents/hoverableIcons/addToFav'
import PlayFromBeginIcon from '../../../assets/imgComponents/hoverableIcons/playFromBeginIcon'

const DefaultContentDetailPage = (props) => {
  let { theme, data } = props

  const contentId = useParams().contentId
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const { t } = useTranslation()
  const {
    isCustomTemplate,
    isLogin,
    setLoader,
    setOpenLoginModal,
    setModalType,
    accountObj,
    modulePermissions,
    userObj,
    setVerifyOtpModalData,
    athletePartnerData,
  } = useContext(AppContext)
  const { setOpenSubscriptionModal, setSubscriptions, setRedirectionUrl, setContentPartners } =
    useContext(SubscriptionContext)
  const {
    isInFavoriteList,
    isInWatchList,
    addRemoveFavouriteList,
    addRemoveWatchList,
    setIsVideoPlaying,
    getResumeTimestamp,
  } = useContext(ContentContext)

  const [publishDateTime, setPublishDateTime] = useState(null)
  const [playingVideo, setPlayingVideo] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [detailObj, setDetailObj] = useState()
  const [isLive, setIsLive] = useState(false)
  const [resumeTime, setResumeTime] = useState(0)
  const navigate = useNavigate()
  const isWatch = searchParams.get('watch') === 'true'
  const [endTime, setEndTime] = useState(null)
  const [shareModal, setShareModal] = useState(false)
  const isAthletePartner = accountObj?.od_resource_allowances?.content_partner_type === 'ATHLETE'

  const [{ data: contentDetail, loading: contentLoading }, contentDetailCall] = useAxios(
    {
      url: `${DETAIL_CONTENT}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: contentWatchUrl, loading: contentWatchUrlLoading }, getContentWatchUrl] = useAxios(
    {
      url: `${CONTENT_WATCH_URL}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  useInterval(async () => {
    if (
      accountObj?.od_resource_allowances?.content_refresh &&
      (detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE')
    ) {
      await contentDetailCall()
    }
  }, 25000)

  useEffect(() => {
    if (!playingVideo) {
      contentDetailCall()
    }
  }, [playingVideo, contentId, isLogin])

  useEffect(() => {
    if (playingVideo) {
      setPlayingVideo(false)
    }
  }, [contentId])

  useEffect(() => {
    if (!isEmpty(detailObj) && isWatch) {
      handleWatchNow(false)
    }
  }, [detailObj])

  useEffect(() => {
    if (contentDetail && contentDetail.success) {
      const contentObj = contentDetail.data

      if (isAthletePartner && !isEmpty(contentObj?.owner)) {
        const owner = contentObj?.owner[0]
        if (owner) {
          const partner = athletePartnerData.find((p) => p._id === owner)
          if (partner?.content_partner_metadata?.page_data?.page_url) {
            return redirectToAthletePage(
              navigate,
              `/athlete${partner?.content_partner_metadata?.page_data?.page_url}?content_id=${contentObj?.content_id}`,
            )
          }
        }
      }

      setShowMore(false)
      setDetailObj(contentObj)
      if (contentObj?.video_type?.includes('LIVE') || contentObj?.audio_type?.includes('LIVE')) {
        setPublishDateTime(new Date(contentObj.publish_time + 'Z').getTime())
        setEndTime(new Date(contentObj.live_expiry_time + 'Z').getTime())
        if (
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            contentObj?.video_type === 'VOD_LIVE') ||
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            new Date(contentObj.live_expiry_time + 'Z').getTime() > Date.now())
        ) {
          setIsLive(true)
        }
      }
      if (isLogin) {
        setResumeTime(getResumeTimestamp(contentId))
      }
    }
  }, [contentDetail])

  useEffect(() => {
    if (contentWatchUrl && contentWatchUrl.success) {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    }
  }, [contentWatchUrl])

  useEffect(() => {
    setLoader((isEmpty(detailObj) && contentLoading) || contentWatchUrlLoading)
  }, [contentLoading, contentWatchUrlLoading])

  const get_video_url = (detailObj) => {
    if (detailObj?.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    } else {
      getContentWatchUrl()
    }
  }

  const handleWatchNow = (isStartOver = false) => {
    captureGAEvent('content', 'content_watch', 'Content', {
      content_id: contentId,
      name: detailObj?.title,
      user_id: userObj?._id || '',
      user_email: userObj?.email_id || '',
    })
    if (
      (detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
      endTime < Date.now()
    ) {
      raiseToast('error', t('stream_ended_toast'))
      return
    }

    if (!detailObj.is_restricted) {
      if (
        detailObj.is_login_required &&
        isLogin &&
        accountObj?.od_resource_allowances?.verify_email_mandatory &&
        !userObj?.is_email_verified
      ) {
        setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
        return
      }

      if (detailObj.is_login_required && !isLogin) {
        setModalType('login')
        setOpenLoginModal(true)
      } else {
        if (accountObj?.od_resource_allowances?.player_page) {
          navigate(`/content-watch/${contentId}`, { state: { isStartOver: isStartOver } })
          return
        }
        get_video_url(detailObj)
      }
    } else {
      if (!isLogin) {
        setModalType('login')
        setOpenLoginModal(true)
      } else {
        if (
          accountObj?.od_resource_allowances?.verify_email_mandatory &&
          !userObj?.is_email_verified
        ) {
          setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
          return
        }

        if (detailObj?.is_purchased_required) {
          let activeSub = [...detailObj.active_subscription.map((item) => item.id)]
          let activePPV = [...detailObj.active_ppv_subscription.map((item) => item.id)]

          setRedirectionUrl(window.location.pathname)
          setContentPartners(detailObj?.owner ? detailObj?.owner : [])
          setSubscriptions([...activeSub, ...activePPV])
          setOpenSubscriptionModal(true)
        } else {
          if (accountObj?.od_resource_allowances?.player_page) {
            navigate(`/content-watch/${contentId}`, { state: { isStartOver: isStartOver } })
            return
          }
          get_video_url(detailObj)
        }
      }
    }
  }

  const getButtonText = () => {
    if (!isLogin || !detailObj.is_restricted || !detailObj?.is_purchased_required) {
      if (detailObj?.asset_type === 'AUDIO') {
        return (
          <div className="flex items-center">
            {' '}
            <ListenIcon color={getStyleValue('play_button', 'play_icon_color', '#000')} />{' '}
            <span className="ml-2.5">{t('listen_now')}</span>
          </div>
        )
      }
      return resumeTime ? (
        <div className="flex items-center">
          <ResumeWatchingIcon color={getStyleValue('play_button', 'play_icon_color', '#000')} />
          <span className="ml-2.5">{t('resume_watching')}</span>
        </div>
      ) : (
        <div className="flex items-center">
          <PlayIcon color={getStyleValue('play_button', 'play_icon_color', '#000')} />
          <span className="ml-2.5">{t('watch_now')}</span>
        </div>
      )
    } else {
      return (
        <div className="flex items-center">
          <PlayIcon color={getStyleValue('play_button', 'play_icon_color', '#000')} />
          <span className="ml-2.5">
            {detailObj?.asset_type === 'AUDIO' ? t('upgrade_plan_listen') : t('upgrade_plan')}
          </span>
        </div>
      )
    }
  }

  const handleCategoryClick = (id) => {
    navigate(`/metadata/${id}`)
  }

  const handleSubCategory = (id) => {
    navigate(`/sub-category/${id}`)
  }

  const onCounterComplete = () => {
    setIsLive(true)
    handleWatchNow(false)
  }

  const executeOnClick = () => {
    setShowMore((showMore) => !showMore)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }
  return (
    <>
      {detailObj && (
        <>
          {playingVideo ? (
            <Player
              contentInfo={detailObj}
              handleClose={() => {
                setPlayingVideo(false)
                setIsVideoPlaying(false)
                setResumeTime(0)
                navigate(location.pathname)
              }}
              contentWatchUrl={
                detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE'
                  ? detailObj.stream.link
                  : contentWatchUrl.data.signed_url
              }
              resumeTime={resumeTime}
            />
          ) : (
            <div
              style={{
                background: getStyleValue('component_background', 'primary_color', theme.c1),
              }}
            >
              {/* <ContentWrapper theme={theme}> */}
              <div style={{}} className="xl:px-[0.8%]">
                <div
                  className={`relative  flex flex-col xl:flex-row  ${
                    data?.aligned !== 'RIGHT' ? 'xl:justify-end' : 'xl:justify-start'
                  } `}
                >
                  <DefaultContentWrapper
                    bg_color={getStyleValue('component_background', 'primary_color', theme.c1)}
                    direction={data?.aligned !== 'RIGHT' ? 'left' : 'right'}
                  >
                    <div
                      style={{ aspectRatio: '16/9' }}
                      className=" default-content-image xl:visible xl:w-[70vw] "
                    >
                      <div className="relative">
                        {(detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
                        !isLive ? (
                          <CustomImage
                            imageUrl={getImage(
                              accountObj?.cf_domain_name,
                              detailObj?.asset_type === 'AUDIO'
                                ? detailObj?.thumbnail
                                : detailObj?.poster,
                            )}
                            loaderClass="content-loader"
                            imgAlt="content"
                            errorPlaceholder={VideoPlaceholder}
                          />
                        ) : (
                          <>
                            {detailObj.preview ? (
                              detailObj?.trailer_type === 'AUDIO' ? (
                                <AudioTrailerPlayer
                                  url={getAudioTrailerUrl(
                                    accountObj?.cf_domain_name,
                                    detailObj.preview,
                                  )}
                                  detailObj={detailObj}
                                  accountObj={accountObj}
                                  isCustomTemplate={isCustomTemplate}
                                  theme={theme}
                                />
                              ) : (
                                <TrailerPlayer
                                  preview={detailObj.preview}
                                  poster={getImage(accountObj?.cf_domain_name, detailObj?.poster)}
                                  quality={480}
                                  type={'CONTENT'}
                                  stream={detailObj.stream}
                                  videoType={detailObj.video_type}
                                  position={data?.aligned !== 'RIGHT' ? 'right-0' : 'left-0'}
                                />
                              )
                            ) : (
                              <CustomImage
                                imageUrl={getImage(
                                  accountObj?.cf_domain_name,
                                  detailObj?.asset_type === 'AUDIO'
                                    ? detailObj?.thumbnail
                                    : detailObj?.poster,
                                )}
                                loaderClass="content-loader"
                                imgAlt="content"
                                errorPlaceholder={VideoPlaceholder}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </DefaultContentWrapper>

                  <div
                    className={`z-10 flex flex-col ${
                      data?.aligned !== 'RIGHT' ? 'items-start left-0' : 'items-end right-0'
                    } xl:absolute w-full xl:w-[94%] 2xl:px-24 xl:px-14 md:px-10 px-4 `}
                    style={{ color: '#e3e2e2' }}
                  >
                    <p
                      style={{
                        color: getStyleValue('content_title', 'color', ''),
                        fontFamily: getStyleValue('content_title', 'font', ''),
                      }}
                      className={`text-2xl md:text-3xl  font-semibold mt-4 xl:mt-10 ${getStyleValue(
                        'content_title',
                        'font_format',
                        'font-semibold',
                      )}`}
                    >
                      {detailObj?.title}
                    </p>
                    {detailObj.release_time && (
                      <div
                        style={{
                          color: getStyleValue('sub_heading', 'color', theme.c4),
                          fontFamily: getStyleValue('sub_heading', 'font', ''),
                        }}
                        className={`${getStyleValue(
                          'sub_heading',
                          'font_format',
                          '',
                        )} flex mt-2 xl:mt-4`}
                      >
                        <p className={' '}>{t('release_date')} :</p>
                        <p className={'ml-2'}>{getReleaseDate(detailObj.release_time)}</p>
                      </div>
                    )}
                    {modulePermissions?.rating && (
                      <div className="mt-3">
                        <AggregateRatingReviewWidget
                          value={detailObj.average_rating}
                          ratingCount={detailObj.review_count}
                          starColor={getStyleValue('ratings_reviews', 'star_color', '#ffee00')}
                          bigTextColor={getStyleValue('ratings_reviews', 'text1_color', '#fff')}
                          bigTextFontSize={'text-xs'}
                          smallTextColor={getStyleValue('ratings_reviews', 'text1_color', '#fff')}
                        />
                      </div>
                    )}

                    {(detailObj?.video_type?.includes('LIVE') ||
                      detailObj?.audio_type?.includes('LIVE')) &&
                      !isLive &&
                      (detailObj.video_type === 'VOD_LIVE' || endTime > Date.now()) && (
                        <LiveCounter
                          contentDetail={detailObj}
                          handleCompletion={onCounterComplete}
                        />
                      )}

                    {detailObj?.duration !== 0 && (
                      <div style={{ display: 'flex' }}>
                        <p
                          style={{
                            color: getStyleValue('sub_heading', 'color', theme.c4),
                            fontFamily: getStyleValue('sub_heading', 'font', ''),
                          }}
                          className={`${getStyleValue(
                            'sub_heading',
                            'font_format',
                            'font-semibold',
                          )} `}
                        >
                          {secondsToHms(detailObj?.duration)}
                        </p>
                      </div>
                    )}
                    <div
                      className={`flex items-center ${
                        data?.aligned !== 'RIGHT' ? '' : 'flex-row-reverse'
                      } mt-5 `}
                    >
                      {!isEmpty(detailObj?.content_rating) ? (
                        <div
                          className={`flex items-center justify-center 
                        ${data?.aligned !== 'RIGHT' ? 'pr-4' : 'pl-4'}
                        `}
                        >
                          {detailObj?.content_rating?.icon?.s3_key && (
                            <div className="mr-1">
                              <img
                                src={getImage(
                                  accountObj?.cf_domain_name,
                                  detailObj?.content_rating?.icon?.s3_key,
                                )}
                                className="w-6 h-6 md:w-10 md:h-10"
                                alt="Rating"
                              />
                            </div>
                          )}
                          <p
                            style={{
                              color: getStyleValue('content_rating_text', 'color', theme.c4),
                            }}
                            className="text-xs md:text-sm"
                          >
                            {detailObj?.content_rating?.name}
                          </p>
                        </div>
                      ) : null}
                      {detailObj?.video_type?.includes('LIVE') ||
                      detailObj?.audio_type?.includes('LIVE') ? (
                        <div style={{ display: 'flex', alignItems: 'center' }} className={'mx-2'}>
                          <button
                            className="px-4 py-1 focus:outline-none"
                            style={{
                              color: !isLive
                                ? getStyleValue('play_button_live', 'button_text', '#bbbbbb')
                                : getStyleValue('play_button', 'button_text', '#000'),
                              backgroundImage: !isLive
                                ? 'transparent'
                                : `linear-gradient(to left
                                  , ${getStyleValue(
                                    'play_button',
                                    'background_color1',
                                    theme.c5,
                                  )}, ${getStyleValue(
                                    'play_button',
                                    'background_color2',
                                    theme.c5,
                                  )})`,
                              borderRadius: '6px',
                              border: !isLive
                                ? `solid 1px ${getStyleValue(
                                    'play_button_live',
                                    'border_color',
                                    '#bbfa33',
                                  )} `
                                : 'none',
                              textTransform: 'uppercase',
                            }}
                            onClick={() => handleWatchNow(false)}
                            disabled={
                              publishDateTime > Date.now() ||
                              (endTime < Date.now() && detailObj?.video_type === 'LIVE')
                            }
                          >
                            {endTime < Date.now() &&
                            (detailObj?.video_type === 'LIVE' ||
                              detailObj?.audio_type === 'LIVE') ? (
                              <div className="flex items-center">
                                <PauseIcon
                                  color={getStyleValue('play_button', 'play_icon_color', '#ffffff')}
                                />
                                <span className="ml-2.5">{t('stream_ended')}</span>
                              </div>
                            ) : !isLive ? (
                              <div className="flex items-center">
                                <StreamingSoonIcon
                                  color={getStyleValue('play_button', 'play_icon_color', '#ffffff')}
                                />
                                <span className="ml-2.5">{t('upcoming')}</span>
                              </div>
                            ) : detailObj.video_type === 'LIVE' ||
                              detailObj?.audio_type === 'LIVE' ? (
                              <div className="flex items-center">
                                <PlayIcon
                                  color={getStyleValue('play_button', 'play_icon_color', '#ffffff')}
                                />
                                <span className="ml-2.5">{t('playing_now')}</span>
                              </div>
                            ) : (
                              <div className="flex items-center">
                                <PlayIcon
                                  color={getStyleValue('play_button', 'play_icon_color', '#ffffff')}
                                />
                                <span className="ml-2.5">{t('watch_now')}</span>
                              </div>
                            )}
                          </button>

                          {(detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
                            endTime > Date.now() && (
                              <div
                                style={{
                                  justifyContent: 'center',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <span
                                  style={{
                                    marginLeft: '15px',
                                    marginRight: '8px',
                                    fontSize: '1.5rem',
                                    color: isCustomTemplate ? theme.c4 : '#fff',
                                  }}
                                >
                                  {t('live')}
                                </span>
                                <img
                                  src={!isLive ? GreyCircle : RedCircle}
                                  style={{ width: '20px', height: '20px' }}
                                  alt={'live'}
                                />
                              </div>
                            )}
                        </div>
                      ) : (
                        <>
                          <button
                            className="px-4 py-1 focus:outline-none mx-2"
                            style={{
                              borderRadius: '6px',
                              color: getStyleValue('play_button', 'button_text', theme.c7),
                              backgroundImage: `linear-gradient(to left
                                  , ${getStyleValue(
                                    'play_button',
                                    'background_color1',
                                    theme.c5,
                                  )}, ${getStyleValue(
                                'play_button',
                                'background_color2',
                                theme.c5,
                              )})`,
                            }}
                            onClick={() => {
                              // setResumeTime(detailObj?.resume_timestamp)
                              handleWatchNow(false)
                            }}
                          >
                            {getButtonText()}
                          </button>
                        </>
                      )}

                      {resumeTime &&
                      detailObj.video_type !== 'LIVE' &&
                      detailObj?.audio_type !== 'LIVE' ? (
                        <div
                          className="w-[22.4px] xl:w-[27px] mx-1 xl:mx-3 cursor-pointer"
                          onClick={() => handleWatchNow(true)}
                        >
                          <PlayFromBeginIcon
                            color={getStyleValue(
                              'operational_icon',
                              'operational_icon_color',
                              '#fff',
                            )}
                            hoverColor={getStyleValue(
                              'operational_icon',
                              'operational_icon_hover_color',
                              '#bbfa33',
                            )}
                            imgClass=" w-full h-auto"
                          />
                        </div>
                      ) : null}
                      <div
                        className=" mx-1 xl:mx-3 cursor-pointer"
                        onClick={() => setShareModal(true)}
                      >
                        <ShareIcon
                          color={getStyleValue(
                            'operational_icon',
                            'operational_icon_color',
                            '#fff',
                          )}
                          hoverColor={getStyleValue(
                            'operational_icon',
                            'operational_icon_hover_color',
                            '#bbfa33',
                          )}
                          imgClass="w-3 xl:w-[14.3px]"
                        />
                      </div>

                      {isLogin && (
                        <div className="flex  justify-between ">
                          <div
                            className=" cursor-pointer mx-1 xl:mx-3 w-[19.1px] xl:w-[22.4px]"
                            onClick={() => addRemoveWatchList(contentId)}
                          >
                            {isInWatchList(contentId) ? (
                              <AddedToPlaylist
                                color={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_color',
                                  '#fff',
                                )}
                                hoverColor={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_hover_color',
                                  '#bbfa33',
                                )}
                                imgClass="w-full h-auto"
                              />
                            ) : (
                              <AddToPlaylist
                                color={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_color',
                                  '#fff',
                                )}
                                hoverColor={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_hover_color',
                                  '#bbfa33',
                                )}
                                imgClass="w-full h-auto"
                              />
                            )}
                          </div>
                          <div
                            className="cursor-pointer mx-1 xl:mx-3 w-[16.2px] xl:w-[19.2px]"
                            onClick={() => addRemoveFavouriteList(contentId)}
                          >
                            {isInFavoriteList(contentId) ? (
                              <AddedToFav
                                color={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_color',
                                  '#fff',
                                )}
                                hoverColor={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_hover_color',
                                  '#bbfa33',
                                )}
                                imgClass="w-full h-auto"
                              />
                            ) : (
                              <AddToFav
                                color={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_color',
                                  '#fff',
                                )}
                                hoverColor={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_hover_color',
                                  '#bbfa33',
                                )}
                                imgClass="w-full h-auto"
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className={`xl:max-h-[18.5vw] hidden-scrollbar-class xl:w-[566px]`}>
                      <p
                        style={{
                          color: getStyleValue('content_description', 'color', '#bbbbbb'),
                          fontFamily: getStyleValue('content_description', 'font', ''),
                        }}
                        className={`${getStyleValue(
                          'content_description',
                          'font_format',
                          '',
                        )} w-full mt-5`}
                      >
                        {contentId && (
                          <ShowMoreText
                            lines={3}
                            more={
                              <span
                                style={{
                                  color: getStyleValue(
                                    'play_button',
                                    'background_color1',
                                    '#bbfa33',
                                  ),
                                }}
                              >
                                {t('show_more')}
                              </span>
                            }
                            less={
                              <span
                                style={{
                                  color: getStyleValue(
                                    'play_button',
                                    'background_color1',
                                    '#bbfa33',
                                  ),
                                }}
                              >
                                {t('show_less')}
                              </span>
                            }
                            anchorClass={`text-sm cursor-pointer `}
                            className={` w-full text-xs md:text-lg ${
                              data?.aligned !== 'RIGHT' ? 'text-left' : 'text-right'
                            }`}
                            expanded={showMore}
                            onClick={executeOnClick}
                            truncatedEndingComponent={'... '}
                          >
                            <p className="w-full">{detailObj?.description}</p>
                          </ShowMoreText>
                        )}
                      </p>
                      <div
                        style={{
                          color: getStyleValue('metadata_titles', 'color', '#bbbbbb'),
                          fontFamily: getStyleValue('metadata_titles', 'font', ''),
                        }}
                        className={`${getStyleValue(
                          'metadata_titles',
                          'font_format',
                          '',
                        )} w-full mt-5`}
                      >
                        {Object.keys(detailObj.artists).map((artist, index) => (
                          <div
                            className={`flex ${
                              data.aligned !== 'RIGHT' ? '' : 'flex-row-reverse text-right'
                            }`}
                            key={index}
                          >
                            <p
                              style={{}}
                              className={'  font-semibold text-sm md:text-md  w-4/12 lg:w-2/12'}
                            >
                              {artist}
                            </p>
                            <div
                              style={{
                                color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                fontFamily: getStyleValue('metadata_values', 'font', ''),
                              }}
                              className={`${getStyleValue(
                                'metadata_values',
                                'font_format',
                                'font-semibold',
                              )}  text-sm md:text-md w-8/12 lg:w-10/12 flex flex-col  xl:flex-row ${
                                data.aligned !== 'RIGHT' ? '' : 'justify-end'
                              }`}
                            >
                              {' '}
                              <p className=" text-right lg:text-left">
                                {detailObj.artists[artist].map((item, index) => (
                                  <span
                                    key={index}
                                    onClick={() => navigate(`/artist/detail/${item.id}`)}
                                    className={'cursor-pointer hover:underline'}
                                  >
                                    {index !== 0 && <span className={''}>{' , '}</span>}
                                    {item.name}
                                  </span>
                                ))}{' '}
                              </p>
                            </div>
                          </div>
                        ))}
                        <div
                          className={`flex ${
                            data.aligned !== 'RIGHT' ? '' : 'flex-row-reverse text-right'
                          }`}
                        >
                          <p
                            style={{}}
                            className={' font-semibold  text-sm md:text-md w-4/12 lg:w-2/12'}
                          >
                            {t('category')}
                          </p>
                          <div
                            style={{
                              color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                              fontFamily: getStyleValue('metadata_values', 'font', ''),
                            }}
                            className={`${getStyleValue(
                              'metadata_values',
                              'font_format',
                              'font-semibold',
                            )}  text-sm md:text-md w-8/12 lg:w-10/12 flex flex-col xl:flex-row ${
                              data.aligned !== 'RIGHT' ? '' : 'justify-end'
                            }`}
                          >
                            {' '}
                            <p className=" text-right lg:text-left">
                              {[...detailObj?.category].map((item, index) => (
                                <span
                                  key={index}
                                  onClick={() => handleCategoryClick(item.id)}
                                  className={'cursor-pointer hover:underline'}
                                >
                                  {index !== 0 && <span className={''}>{' , '}</span>}
                                  {item.name}
                                </span>
                              ))}
                            </p>
                          </div>
                        </div>
                        {!isEmpty(detailObj.sub_category) && (
                          <div
                            className={`flex ${
                              data.aligned !== 'RIGHT' ? '' : 'flex-row-reverse text-right'
                            }`}
                          >
                            <p
                              style={{}}
                              className={' font-semibold text-sm md:text-md w-4/12 lg:w-2/12'}
                            >
                              {t('genre')}
                            </p>
                            <div
                              style={{
                                color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                fontFamily: getStyleValue('metadata_values', 'font', ''),
                              }}
                              className={`${getStyleValue(
                                'metadata_values',
                                'font_format',
                                'font-semibold',
                              )}  text-sm md:text-md font-semibold w-8/12 lg:w-10/12 flex flex-col xl:flex-row ${
                                data.aligned !== 'RIGHT' ? '' : 'justify-end'
                              }`}
                            >
                              <p className=" text-right lg:text-left">
                                {detailObj.sub_category.map((item, index) => (
                                  <span
                                    key={index}
                                    onClick={() => handleSubCategory(item.id)}
                                    className={'cursor-pointer hover:underline'}
                                  >
                                    {index !== 0 && <span className={''}>{' , '}</span>}
                                    {item.name}
                                  </span>
                                ))}
                              </p>
                            </div>
                          </div>
                        )}
                        {!isEmpty(detailObj.venues) && (
                          <div
                            className={`flex ${
                              data.aligned !== 'RIGHT' ? '' : 'flex-row-reverse text-right'
                            }`}
                          >
                            <p
                              style={{}}
                              className={' font-semibold text-sm md:text-md w-4/12 lg:w-2/12'}
                            >
                              {t('venue')}
                            </p>
                            <div
                              style={{
                                color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                fontFamily: getStyleValue('metadata_values', 'font', ''),
                              }}
                              className={`${getStyleValue(
                                'metadata_values',
                                'font_format',
                                'font-semibold',
                              )}   text-sm md:text-md font-semibold w-8/12 lg:w-10/12 flex flex-col xl:flex-row ${
                                data.aligned !== 'RIGHT' ? '' : 'justify-end'
                              } `}
                            >
                              <p className=" text-right lg:text-left">
                                {detailObj.venues.map((item, index) => (
                                  <span
                                    key={index}
                                    onClick={() => navigate(`/venue/detail/${item.id}`)}
                                    className={'cursor-pointer hover:underline'}
                                  >
                                    {index !== 0 && <span className={''}>{' , '}</span>}
                                    {item.name}
                                  </span>
                                ))}
                              </p>
                            </div>
                          </div>
                        )}

                        {detailObj.custom_metadata_new ? (
                          <CustomMetadata
                            customMetadata={detailObj.custom_metadata_new}
                            nameClass={'font-semibold text-sm md:text-md w-4/12 lg:w-2/12'}
                            valueClass={`text-sm md:text-md w-8/12 lg:w-10/12 flex flex-col xl:flex-row
                              ${data.aligned !== 'RIGHT' ? '' : 'justify-end'}
                              `}
                            valueColor={getStyleValue('metadata_values', 'color', '#bbfa33')}
                            valueFontFamily={getStyleValue('metadata_values', 'font', '')}
                            valueFontFormat={getStyleValue(
                              'metadata_values',
                              'font_format',
                              'font-semibold',
                            )}
                            parentDivClass={`flex ${
                              data.aligned !== 'RIGHT' ? '' : 'flex-row-reverse text-right'
                            }`}
                          />
                        ) : null}
                      </div>
                    </div>
                    {(detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
                      endTime < Date.now() && (
                        <div
                          className={`z-10 xl:absolute py-5`}
                          style={{ top: '35%', left: '60%' }}
                        >
                          <p
                            style={{ color: isCustomTemplate ? theme.c4 : '#fff' }}
                            className={' text-md md:text-2xl xl:text-3xl text-center mb-2'}
                          >
                            {t('stream_ended')}{' '}
                          </p>
                          <p
                            style={{ color: isCustomTemplate ? theme.c4 : '#fff' }}
                            className={' text-md md:text-2xl xl:text-3xl text-center mb-2'}
                          >
                            {t('thanks_for_watching')}{' '}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              {/* </ContentWrapper> */}
              <div>
                <ContentDetailBottom
                  detailObj={detailObj}
                  theme={theme}
                  data={data}
                  alignment={data.aligned !== 'RIGHT' ? 'left' : 'right'}
                />
              </div>
            </div>
          )}
          {shareModal && (
            <ShareModal
              onClose={() => setShareModal(false)}
              link={create_share_url()}
              detailObj={detailObj}
            />
          )}
        </>
      )}
    </>
  )
}

export default withTheme(DefaultContentDetailPage)
